var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 187,
    viewBox: "0 0 120 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.056 172.434C118.318 174.092 117.532 175.662 116.049 176.448C112.035 178.891 106.799 180.811 100.604 182.294C93.4486 184.039 86.1188 184.912 78.7889 184.912C67.1833 184.912 57.3229 183.254 49.295 180.2C41.267 177.146 34.9843 172.259 30.7086 165.453C26.4328 158.647 24.3386 149.746 24.3386 138.49V83.6902H6.18848C3.83246 83.6902 2 81.7705 2 79.4145V49.9206C2 47.5646 3.91972 45.7321 6.18848 45.7321H24.3386V19.205C24.3386 17.3726 25.5602 15.7146 27.3927 15.1911L73.9896 2.18931C76.2584 1.57849 78.6144 2.88739 79.2252 5.15615C79.3125 5.50519 79.3997 5.94149 79.3997 6.29053V45.7321H112.122C114.478 45.7321 116.398 47.5646 116.398 49.9206V79.4145C116.398 81.7705 114.566 83.6902 112.21 83.6902H79.3997V129.764C79.3997 136.134 80.7959 140.584 83.5882 143.376C86.3805 146.168 90.569 147.477 96.2409 147.477C99.7313 147.477 103.222 147.216 106.625 146.343C109.504 145.645 112.297 144.423 114.827 142.853L118.056 172.346V172.434Z",
    fill: "#191818",
    stroke: "#F57423",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT);
export default __webpack_public_path__ + "static/media/t.d75ee0b2dd4b0372ec89fee422ddf408.svg";
export { ForwardRef as ReactComponent };